import { makeStyles } from '@material-ui/core';
import { doveGray } from '../../../constants/Colors';

export default makeStyles(() => ({
    root: {},
    logo: {},
    image: {
        height: 24,
    },
    urlWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: '0.8rem',
        textDecoration: 'none',
        color: doveGray,
        fontWeight: 600,
        whiteSpace: 'break-spaces',
        width: 100,
    },
    label: {
        paddingLeft: 10,
    },
}));
